import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedNew202605: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_new_202605",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-05-01",
  endDate: "2026-05-31",
  impressions: 7663,
  clicks: 115,
  adsSpendDollars: 513,
  budgetDollars: 14500,
  salesDollars: 1691,
  bestEstimateRoas: 3.3,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.04,
  newCustomersAcquired: 4,
  dataAvailableAtDate: "2026-06-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
